@if (clientConfig?.notetakerEnabled) {
  <main>
    @if (!selectedCall; ) {
      <div class="call-list-container">
        <h2 class="heading-underline with-icon">
          <mat-icon class="phone-icon" fontIcon="phone"></mat-icon>
          <span id="title" class="truncate" matTooltip="{{bullhornCardContext.cardEntityName && 'Calls with'}} {{bullhornCardContext.cardEntityName}}" matTooltipShowDelay="500">{{bullhornCardContext.cardEntityName && 'Calls with'}} {{bullhornCardContext.cardEntityName}}</span>
          @if (dataSource.data.length > 0) {
            <span class="clear-input">
              <input #searchInput
                     class="search-profiles"
                     type="text"
                     placeholder="Search all calls..."
                     (keyup)="filterSearchText($event)"
              >
              <i #clearSearch
                 class="clear-icon"
                 [ngClass]="searchInput.value ? 'bhi-times' : 'bhi-search'"
                 (click)="clearInput(searchInput, true)"
                 (keydown.enter)="clearInput(searchInput, true)"
                 [matTooltip]="searchInput.value ? 'Clear' : ''"
                 matTooltipShowDelay="500"
                 tabindex="0"
              ></i>
            </span>
          }
            <div id="date-picker">
              <mat-datepicker #picker></mat-datepicker>
              <input (dateChange)="filterByDate($event)" [matDatepicker]="picker"
                     [(ngModel)]="filterDateModel">
                <p [ngClass]="{'hide' : !currentFilter.date}">
                  <span (click)="picker.open()" (keydown.enter)="picker.open()"
                    (keydown.space)="picker.open()" matTooltip="Filter by date"
                  matTooltipShowDelay="500" tabindex="0">{{ filterDateModel | date:'MMM d, y' }}</span>
                  <mat-icon fontIcon="close" class="material-icons-outlined danger-btn-hover" (click)="clearDateFilter()"
                    (keydown.enter)="clearDateFilter()" (keydown.space)="clearDateFilter()"
                  matTooltip="Clear date filter" matTooltipShowDelay="500" tabindex="0"></mat-icon>
                </p>
                <mat-icon fontIcon="calendar_month" class="material-icons-outlined calendar" (click)="picker.open()"
                  (keydown.enter)="picker.open()" (keydown.space)="picker.open()"
                matTooltip="Filter by date" matTooltipShowDelay="500" tabindex="0"></mat-icon>
              </div>
              @if (shouldShowUpload()) {
                <aside class="small-button-group">
                  <input #fileInput
                         type="file"
                         accept="{{ uploadDialogExtFilter }}"
                         style="display: none;"
                         (change)="onFileSelected($event)"
                  >
                  <button theme="small" class="upload-button" (click)="triggerFileInput()"
                    matTooltip="Upload a call from your computer" matTooltipShowDelay="500">
                    <span class="upload-call-text">UPLOAD CALL</span>
                    <mat-icon fontIcon="phone_callback" class="watermark"></mat-icon>
                    <mat-icon fontIcon="phone_callback"></mat-icon>
                  </button>
                  <button class="bullhorn-files" theme="small" [matMenuTriggerFor]="menu"
                    [matTooltip]="files.length > 0 ? 'Select a call from Bullhorn' : 'No recordings or transcripts for this entity'" matTooltipShowDelay="500"
                    [disabled]="files.length === 0">
                    <i class="bhi-bull"></i> <!-- This one for the watermark background -->
                    <i class="bhi-bull"></i>
                    <mat-icon class="bullhorn-dropdown" fontIcon="expand_more"></mat-icon>
                  </button>
                </aside>
              }
              <mat-icon fontIcon="settings" class="settings-icon" (click)="openSettingsDialog()"
              matTooltip="Calendar Integration Settings" matTooltipShowDelay="500"></mat-icon>
              <mat-menu #menu="matMenu" class="width-60">
                @for (file of files; track file) {
                  <button mat-menu-item (click)="openUploadDialog(file)">
                    {{file.name}}<span class="secondary-info">{{file.type}}</span>
                  </button>
                }
              </mat-menu>
            </h2>
            <section class="scrollable-container">
              <table mat-table class="table-striped row-highlight" [dataSource]="dataSource"
                matSort matSortActive="date" matSortDirection="desc">
                <!-- Description Column -->
                <!--        ToDo: Rename all instances of where this says description to name (if needed)-->
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Call name</th>
                  <td mat-cell *matCellDef="let element"
                    [ngClass]="{'disabled-cell': isRowDisabled(element)}"
                    [matTooltip]="isRowDisabled(element) ? 'Details not available' : element.description"
                    matTooltipShowDelay="500">
                    <span class="truncate-3-lines">{{ element.description }}</span>
                  </td>
                </ng-container>
                <!-- Duration Column -->
                <ng-container matColumnDef="duration">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Duration</th>
                  <td mat-cell *matCellDef="let element"
                    [ngClass]="{'disabled-cell': isRowDisabled(element)}">
                    @if (element.duration !== '0m 0s') {
                      <mat-icon fontIcon="timer" class="material-icons-outlined duration"></mat-icon> {{ element.duration }}
                    }
                  </td>
                </ng-container>
                <!-- Date Column -->
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Date of Call (UTC)</th>
                  <td mat-cell *matCellDef="let element"
                    [ngClass]="{'disabled-cell': isRowDisabled(element)}">
                    {{ element.date | date:'medium' }}
                  </td>
                </ng-container>
                <!-- Note Action Column -->
                <ng-container matColumnDef="noteAction">
                  <th mat-header-cell *matHeaderCellDef>{{ noteActionColumnLabel }}</th>
                  <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                    @if (element.displaySummaryPath?.path?.[0] === 'Note') {
                      <mat-select
                        class="note-action-select"
                        [value]="element.noteAction"
                        (selectionChange)="onNoteActionChange(element, $event.value)"
                        placeholder="Select action...">
                        @for (action of noteActionTypes; track action) {
                          <mat-option [value]="action">{{ action }}</mat-option>
                        }
                      </mat-select>
                    } @else {
                      <span class="no-note-action">—</span>
                    }
                  </td>
                </ng-container>
                <!-- Actions Column -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <div class="action-container">
                      @if (!openInBowlingAlley) {
                        <mat-icon
                          class="icon"
                          matTooltip="Open in new Bullhorn tab"
                          matTooltipShowDelay="500"
                          (click)="open(element, $event)"
                        fontIcon="open_in_new"></mat-icon>
                      }
                      <mat-icon matTooltip="Delete {{element.description}}" matTooltipShowDelay="500"
                        class="danger-btn-hover"
                        (click)="delete(element, $event)"
                      fontIcon="delete_outline"></mat-icon>
                      @if (isRowDisabled(element)) {
                        <mat-icon fontIcon="cloud_upload" class="red-icon icon"
                          [matTooltip]="isUploadTriggered ? 'Upload already triggered' : 'Failed to Upload - Retry'"
                          [matTooltipDisabled]="isUploadTriggered"
                        (click)="isUploadTriggered ? null : onReupload(element, $event)"></mat-icon>
                      } @else {
                        @if (element.status === 'ERROR' && !isRowDisabled(element)) {
                          <mat-icon fontIcon="switch_access_shortcut" class="red-icon icon"
                            (click)="onRetry(element, $event)"
                          matTooltip="Retry Generating Answers"></mat-icon>
                        } @else {
                          @if (!isRowDisabled(element)) {
                            <app-ai-stars-generating
                              [generating]="element.status == MeetingStatus.IN_PROGRESS"
                              (click)="showCallDetails(element)"
                              [matTooltip]="element.status == MeetingStatus.COMPLETE ? 'View transcript' : 'Generating transcript'"
                              matTooltipShowDelay="500">
                            </app-ai-stars-generating>
                          }
                        }
                      }
                    </div>
                  </td>
                </ng-container>
                <!-- Header and Data Row Definitions -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                  [ngClass]="{'disabled-row': isRowDisabled(row)}"
                  (click)="isRowDisabled(row) ? $event.stopPropagation() : onRowClick(row)">
                </tr>
              </table>
              @if ((dataSource?.data?.length === 0)) {
                <div class="no-results"> <!-- TODO: Hide while loading-->
                  @if (dataSource?.data?.length === 0) {
                    <span>NO CALLS ADDED, UPLOAD ONE FROM ABOVE</span>
                  }
                  @if (dataSource?.data?.length !== 0) {
                    <span>NO CALLS FOUND</span>
                  }
                </div>
              }
              <!--    <app-skeleton *ngIf="loading" [style]="'big-row-table'" [count]="4"></app-skeleton>-->
            </section>
          </div>
        }
        <!-- Show the results for particular file -->
        @if (selectedCall) {
          <app-notetaker-result [call]="selectedCall" [bullhornCardContext]="bullhornCardContext" (clearSelectedCall)="selectedCall = $event"></app-notetaker-result>
        }
      </main>
    }
    <div id="version-number" [ngClass]="{'expand-version': expandVersion}" title="Double click to copy - {{environment.environmentIdentifier}} v{{appVersion}}"
      (dblclick)="copyToClipboard(environment.environmentIdentifier + ' v' + appVersion)">
      @if (environment.environmentIdentifier !== 'PROD') {
        ENV: {{ environment.environmentIdentifier }}
      }
      v{{ appVersion }}
    </div>
